// AppLockSection — Settings page section for the app lock.
// Renders the LockMenu inline so users can enable / change / remove the
// password from Settings as well as from the header dropdown.

import { LockMenu } from '../AppLock';

export function AppLockSection() {
  return (
    <div className="settings-section">
      <h3>App Lock</h3>
      <p className="field-hint">
        Protect access to this calculator with a password. The lock screen
        appears when the app starts and after idle periods.
      </p>
      <LockMenu variant="inline" />
    </div>
  );
}
